import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/use-auth';
import {
  SECCIONES_DE_MI_EMPRESA_EN_LA_DEMO,
  esEmpresaDemo,
  esSeccionDelPlanCompletoEnLaDemo,
} from '@/features/mini-prixia/empresa-demo';
import { VolverConElPlanCompleto } from '@/features/mini-prixia/components/volver-con-el-plan-completo';
import { esSeccion } from '../lib/secciones';
import { useEmpresaStore } from '../store/empresa-store';
import { ResumenSection } from '../sections/resumen-section';
import { UsuariosSection } from '../sections/usuarios-section';
import { RolesSection } from '../sections/roles-section';
import { EquiposSection } from '../sections/equipos-section';
import { AprobacionesSection } from '../sections/aprobaciones-section';
import { DocumentosSection } from '../sections/documentos-section';
import { PagosSection } from '../sections/pagos-section';

/**
 * Mi empresa (maqueta de Melanie, 25-oct): `/mi-empresa` es el Resumen y
 * `/mi-empresa/<seccion>` cada pestaña. Todo es de administración: quien no es
 * admin va a lo único de la empresa que puede abrir (el diseño de la
 * cotización del Pricer) o a su perfil.
 */
export function MiEmpresaPage() {
  const { seccion } = useParams();
  const { user, isAdmin, canSeeMenu, isModuleLocked } = useAuth();
  const cargar = useEmpresaStore((s) => s.cargar);

  useEffect(() => {
    if (user?.tenantId) void cargar(user.tenantId);
  }, [user?.tenantId, cargar]);

  if (!isAdmin) {
    if (canSeeMenu('pricer-datec') && !isModuleLocked('pricer-datec'))
      return <Navigate to="/pricer-datec/configuracion" replace />;
    return <Navigate to="/profile" replace />;
  }
  /*
    Demo (Ronda Z, P1): sólo se abre Usuarios. Sin pestaña, entra por ahí; las demás
    son del plan completo y muestran el cuadro, igual que el candado del menú.
  */
  if (esEmpresaDemo()) {
    if (!esSeccion(seccion))
      return <Navigate to={`/mi-empresa/${SECCIONES_DE_MI_EMPRESA_EN_LA_DEMO[0]}`} replace />;
    if (esSeccionDelPlanCompletoEnLaDemo(seccion)) return <VolverConElPlanCompleto />;
  }
  if (!esSeccion(seccion)) return <Navigate to="/mi-empresa/resumen" replace />;

  switch (seccion) {
    case 'usuarios':
      return <UsuariosSection />;
    case 'roles':
      return <RolesSection />;
    case 'equipos':
      return <EquiposSection />;
    case 'aprobaciones':
      return <AprobacionesSection />;
    case 'documentos':
      return <DocumentosSection />;
    case 'pagos':
      return <PagosSection />;
    default:
      return <ResumenSection />;
  }
}

export default MiEmpresaPage;
